import { BoxIcon, CodeIcon, FitIcon, HandIcon, ImageIcon, PanelRightIcon, PointerIcon, TypeIcon, VideoIcon, WrenchIcon, XIcon } from '../ProductFrameIcons'

const btn = 'flex size-8 items-center justify-center rounded-md text-muted'

/** The floating create rail on Artboard and Workflow: Text, Image, Video, 3D, Vibe-code, then Utilities. */
export function ToolRail({ active }: { active?: number }) {
  return (
    <div className="absolute top-3 bottom-3 left-3 z-10 flex w-11 flex-col items-center gap-1 rounded-xl border border-line bg-card py-2 shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      {[TypeIcon, ImageIcon, VideoIcon, BoxIcon, CodeIcon].map((Icon, i) => (
        <span key={i} className={`${btn} ${i === active ? 'bg-panel text-bone' : ''}`}>
          <Icon width={15} height={15} />
        </span>
      ))}
      <span className="my-1 h-px w-6 bg-line" />
      <span className={btn}>
        <WrenchIcon width={15} height={15} />
      </span>
      <span className={`${btn} mt-auto`}>
        <XIcon width={13} height={13} />
      </span>
      <span className={btn}>
        <PanelRightIcon width={15} height={15} />
      </span>
    </div>
  )
}

/** Select, pan, fit: the floating strip at the bottom of the canvas. */
export function CanvasTools({ className = '' }: { className?: string }) {
  return (
    <div className={`absolute bottom-3 z-10 flex -translate-x-1/2 items-center gap-1 rounded-xl border border-line bg-card p-1 shadow-[0_2px_8px_rgba(0,0,0,0.05)] ${className}`}>
      <span className={`${btn} bg-panel text-bone`}>
        <PointerIcon width={15} height={15} />
      </span>
      <span className={btn}>
        <HandIcon width={15} height={15} />
      </span>
      <span className={btn}>
        <FitIcon width={15} height={15} />
      </span>
    </div>
  )
}

/** Dot grid behind Board and Flow. */
export const canvasBg = 'bg-ground bg-[radial-gradient(rgba(2,2,2,0.08)_1px,transparent_1px)] bg-[size:18px_18px]'
